import React, { useEffect, useMemo, useState } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { UserRole, restRepository } from "@onair/repositories";
import { Label } from "@onair/minimal-ui/label";
import { useQuery } from "@tanstack/react-query";
import { TabContext, TabList } from "@mui/lab";
import { Tab } from "@mui/material";

export enum NotificationRoleTab {
	ALL = "all",
	HOST = UserRole.HOST,
	USER = UserRole.USER,
}

interface PropTypes {
	value: NotificationRoleTab;
	enabled?: boolean;
	onChange: (
		event: React.SyntheticEvent,
		newValue: NotificationRoleTab,
	) => void;
}

export const NotificationTabs = ({
	value,
	enabled = true,
	onChange,
}: PropTypes) => {
	const { data } = useQuery({
		queryKey: ["notifications-count"],
		queryFn: () => restRepository.api.countNotifications(),
		enabled,
	});

	const countNotification = data?.data;

	return (
		<TabContext value={value}>
			<Box
				sx={{
					px: 2,
					borderBottom: "1px solid #919EAB33",
				}}
			>
				<TabList onChange={onChange}>
					<Tab
						label={
							<Stack direction="row" spacing={1}>
								<Typography variant="body2" sx={{ fontWeight: 600 }}>
									Tất cả
								</Typography>
								<Label variant="filled" color="default">
									{countNotification?.total || 0}
								</Label>
							</Stack>
						}
						value={NotificationRoleTab.ALL}
					/>
					<Tab
						label={
							<Stack direction="row" spacing={1}>
								<Typography variant="body2" sx={{ fontWeight: 600 }}>
									Host
								</Typography>
								<Label variant="soft" color="info">
									{countNotification?.[UserRole.HOST] || 0}
								</Label>
							</Stack>
						}
						sx={{ fontWeight: 600 }}
						value={NotificationRoleTab.HOST}
					/>
					<Tab
						label={
							<Stack direction="row" spacing={1}>
								<Typography variant="body2" sx={{ fontWeight: 600 }}>
									Cá nhân
								</Typography>
								<Label variant="soft" color="success">
									{countNotification?.[UserRole.USER] || 0}
								</Label>
							</Stack>
						}
						sx={{ fontWeight: 600 }}
						value={NotificationRoleTab.USER}
					/>
				</TabList>
			</Box>
		</TabContext>
	);
};
